import React from 'react'
import { Schedule } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import { FrecuencyEmailId } from '../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'
import ModalSelectScheduleEmail from './ModalSelectScheduleEmail/ModalSelectScheduleEmail'
import { ScheduleFrecuency } from '../../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'

type ConModalSelectScheduleEmailProps = {
    schedule?: Schedule
    frecuencyId: FrecuencyEmailId
    onCloseModal: () => void
    onSet: (schedule: ScheduleFrecuency) => void
}

const ConModalSelectScheduleEmail = ({
    schedule,
    frecuencyId,
    onCloseModal,
    onSet
}: ConModalSelectScheduleEmailProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalSelectScheduleEmail
                              frecuencyId={frecuencyId}
                              onSet={onSet}
                              onCloseModal={onCloseModal}
                              schedule={schedule}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalSelectScheduleEmail )